import { MultiSelect } from 'primereact/multiselect';
import { withTranslation, WithTranslation } from "react-i18next";
import React from "react";
import { TFunction } from "i18next";
import {Tooltip} from "primereact/tooltip";

import { FormService } from "../../../form/services/FormService";
import { Toast } from "primereact/toast";
import { Button } from "primereact/components/button/Button";
import { DataTable } from "primereact/components/datatable/DataTable";
import { Column } from "primereact/components/column/Column";
import "./FormEditorSidebar.scss";
import { Form } from "../../../form/models/Form";
import { FormEditorService } from "../services/FormEditorService";
import { SeverityEnum } from "../../../shared/enum/SeverityEnum";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { QuestionType } from "../../../form/enum/QuestionType";
import { InputText } from "primereact/inputtext";
import { Chips } from 'primereact/chips';
import { Toolbar } from "primereact/toolbar";
import { FormType } from "../../../form/enum/FormType";
import { RadioButton } from "primereact/radiobutton";
import { DecisionTree } from "../../../admin/models/DecisionTree";
import {InputNumber} from "primereact/inputnumber";
import {AdminScriptsService} from "../../services/AdminScriptsService";
import {Script} from "../../models/Script";


interface States {
  questions: any[];
  currentQuestion: any;
  displayAddQuestionDialog: boolean;
  displayDeleteAllQuestionDialog: boolean;
  displayConfigFormDialog: boolean;
  currentNewQuestion: any;
  currentNewQuestionType: any;
  formConfig: {
      googleTag: string,
      prismic: string[],
      languages: string[],
      defaultLanguage: string,
      type: FormType,
      pdfWidth: number,
      docxGeneration: boolean,
      excelGeneration: boolean;
      pdfFromDocx: boolean,
      pdfFromHTML: boolean,
      mailTo: string[],
      graphDecisionTree: string | null,
      diagramDecisionTree: string | null,
      defaultScriptName: string | null,
      defaultSubmissionName: string | null };
  form: Form | null;
  scriptList: Script[];
}

interface Props extends WithTranslation {
  questions: any[];
  form: Form | null;
  onQuestionSelection: (question) => void;
  refreshQuestionList: () => void;
  prismicKeys: string[];
  addQuestion: (question) => void;
  deleteAllQuestion: () => void;
  saveFormConfig: (formConfig) => void;
  currentQuestion: any;
  decisionTrees: DecisionTree[]
}

class FormEditorSidebar extends React.Component<Props, States> {

  private t: TFunction;
  private formService: FormService;
  private formEditorService: FormEditorService;
  private scriptService: AdminScriptsService;
  private toast: Toast | null;

  constructor(props: Props) {
    super(props);
    this.formService = new FormService();
    this.formEditorService = new FormEditorService();
    this.scriptService = new AdminScriptsService();
    this.t = this.props.t;
    this.toast = null;

    this.state = {
      questions: [],
      currentQuestion: null,
      displayAddQuestionDialog: false,
      displayDeleteAllQuestionDialog: false,
      displayConfigFormDialog: false,
      currentNewQuestionType: null,
      currentNewQuestion: null,
      formConfig: {
          googleTag: '',
          prismic: [],
          languages: [],
          defaultLanguage: '',
          type: FormType.REQUIREMENT,
          pdfWidth: 1200,
          docxGeneration: false,
          excelGeneration: false,
          pdfFromDocx: false,
          pdfFromHTML: false,
          mailTo: [],
          graphDecisionTree: null,
          diagramDecisionTree: null,
          defaultScriptName: null,
          defaultSubmissionName: null },
      form: null,
      scriptList: [],
    };
  }

  componentDidMount() {
    this._getScripts();
  }

  private _onQuestionOrder(e: any) {
    this.formEditorService.updateQuestions(e).then(() => {
      this.props.refreshQuestionList();
      this.toast?.show({
        severity: SeverityEnum.SUCCESS,
        detail: 'Question déplacée!',
      });
    });
  }

    private _getScripts() {
        this.scriptService.getMany()
            .then((res) => {
                this.setState({
                    scriptList: res.data
                });
            });
    }

  componentWillReceiveProps(nextProps: Readonly<Props>, nextContext: any) {
    this.setState({
      questions: nextProps.questions
    });
    if (nextProps.form) {
      const formConfig = {
        googleTag: nextProps.form.googleTag ?? '',
        prismic: nextProps.form.prismic ?? [],
        languages: nextProps.form.languages ?? [],
        defaultLanguage: nextProps.form.defaultLanguage ?? '',
        type: nextProps.form.type ?? FormType.REQUIREMENT,
        pdfWidth: nextProps.form.pdfWidth ?? 1200,
        docxGeneration: nextProps.form.docxGeneration ?? false,
        excelGeneration: nextProps.form.excelGeneration ?? false,
        pdfFromDocx: nextProps.form.pdfFromDocx ?? false,
        pdfFromHTML: nextProps.form.pdfFromHTML ?? false,
        mailTo: nextProps.form.mailTo ?? [],
        graphDecisionTree: nextProps.form.graphDecisionTree ?? null,
        diagramDecisionTree: nextProps.form.diagramDecisionTree ?? null,
        defaultScriptName: nextProps.form.defaultScriptName ?? "",
        defaultSubmissionName: nextProps.form.defaultSubmissionName ?? "",
      };

      this.setState({
        formConfig
      });
    }
    if (nextProps.currentQuestion) {
      this.setState({
        currentQuestion: nextProps.currentQuestion
      });
    }
  }

  private _renderAddQuestionDialogFooter() {
    return (
      <div>
        <Button
          label="Cancel"
          icon="pi pi-times"
          style={{ backgroundColor: '#0087b7', borderColor: '#0087b7' }}
          onClick={() => this.setState({
            displayAddQuestionDialog: false,
            currentNewQuestion: null,
            currentNewQuestionType: null
          })}
          className="p-mb-2"
        />
        <Button
          label="Sauver"
          icon="pi pi-check"
          style={{ backgroundColor: '#e98b3a', borderColor: '#e98b3a' }}
          onClick={() => {
            let question: any = {
              values: [],
              question: this.state.currentNewQuestion,
              type: this.state.currentNewQuestionType
            };
            switch (question.type) {
              case QuestionType.NUMBER:
                question.validation = {
                  min: 0,
                  step: 1
                };
            }
            this.props.addQuestion(question);
            this.setState({
              displayAddQuestionDialog: false,
            });
          }}
          disabled={(!this.state.currentNewQuestionType || !this.state.currentNewQuestion)}

          className="p-mb-2"
        />
      </div>
    );
  }

  private _addNewEmptyQuestion() {
    let question: any = {
      values: [],
      question: `New_question_${this.state.questions.length + 1}`,
      type: null
    };
    for (const q of this.props.questions) {
      //check if question already exist
      if (q.question === question.question) {
        this.toast?.show({
          severity: SeverityEnum.ERROR,
          detail: `Question with the name ${question.question} already exists !`,
        });
        return;
      }
    }
    this.props.addQuestion(question);
    this.setState({ currentQuestion: question });
    this.props.onQuestionSelection(question);
    this.setState({
      displayAddQuestionDialog: false,
    });
  }

  //region RENDERING

  private _renderQuestionsList() {
    return (
      <>
        <DataTable className="questionList" value={this.state.questions}
                   id="p-datatable-scrollable-body"
                   reorderableColumns
                   onRowReorder={(e: any) => {
                     this._onQuestionOrder(e.value);
                   }}
                   selection={this.state.currentQuestion}
                   onSelectionChange={e => {
                     this.setState({ currentQuestion: e.value });
                     this.props.onQuestionSelection(e.value);
                   }}
                   selectionMode="single"
                   dataKey="question"
                   scrollHeight="70vh"
                   scrollable
        >
          <Column
            key="question"
            columnKey="question"
            field="question"
            style={{ width: '50px' }}
            header="List of questions"
          />
          <Column
            rowReorder
            style={{ width: '15px' }}
            rowReorderIcon="pi pi-ellipsis-v"
          />
        </DataTable>
      </>
    )
  }

  private _renderToolBarOfQuestionsList() {
    return (
      <>
        <Toolbar
          left={() => (
            <div>
              <Button
                type="button"
                icon="pi pi-cog"
                tooltip="Config form"
                onClick={() => this.setState({ displayConfigFormDialog: true })}
                style={{ backgroundColor: '#0087b7', borderColor: '#0087b7' }}
                className="p-button-secondary" />
              <Button
                icon="pi pi-plus"
                tooltip="Add question"
                style={{ backgroundColor: '#e98b3a', borderColor: '#e98b3a' }}
                onClick={() => this._addNewEmptyQuestion()}
                className="p-button-success" />
            </div>
          )}
        />
      </>
    )
  }

  private _renderAddQuestionModal() {
    let questionTypes: any[] = [];
    for (let i in QuestionType) {
      questionTypes.push({ name: QuestionType[i], label: QuestionType[i] });
    }

    return (
      <>
        <Dialog
          id="addQuestionDialog"
          header={"Add question"}
          footer={this._renderAddQuestionDialogFooter()}
          visible={this.state.displayAddQuestionDialog}
          style={{ width: '600px' }}
          onHide={() => {
            this.setState({
              displayAddQuestionDialog: false,
              currentNewQuestion: null,
              currentNewQuestionType: null
            });
          }}>
          <div>
            <div>
              <label>Question: </label>
              <Dropdown
                value={this.state.currentNewQuestion}
                options={this.props.prismicKeys}
                onChange={(e) => {
                  this.setState({ currentNewQuestion: e.value.name ?? e.value });
                }}
                filter
                editable
                appendTo={document.body}
                placeholder="Select a question" />
            </div>
            <div>
              <label>Type: </label>
              <Dropdown
                value={this.state.currentNewQuestionType}
                options={questionTypes}
                onChange={(e) => {
                  this.setState({ currentNewQuestionType: e.value.name ?? e.value });
                }}
                filter
                editable
                appendTo={document.body}
                placeholder="Select a question" />
            </div>
          </div>
        </Dialog>
      </>
      )
  }

  private _renderDeleteAllQuestionsModal() {
    return (
      <>
        <Dialog
          header="Confirmation"
          visible={this.state.displayDeleteAllQuestionDialog}
          modal style={{ width: '450px' }}
          footer={(
            <div>
              <Button label="No" icon="pi pi-times"
                      onClick={() => this.setState({ displayDeleteAllQuestionDialog: false })}
                      className="p-button-text" />
              <Button label="Yes" icon="pi pi-check" onClick={() => {
                this.props.deleteAllQuestion();
                this.setState({
                  displayDeleteAllQuestionDialog: false
                });
              }}
              />
            </div>
          )}
          onHide={() => this.setState({ displayDeleteAllQuestionDialog: false })}>
          <div className="confirmation-content">
            <i className="pi pi-exclamation-triangle p-mr-3" style={{ fontSize: '2rem' }} />
            <span>Voulez-vous supprimer toutes les questions ?</span>
          </div>
        </Dialog>
      </>
    )
  }

  //region FORMCONFIG RENDERING

  private _renderFormConfigModal() {
    return (
      <>
        <Dialog
          header="Form configuration"
          visible={this.state.displayConfigFormDialog}
          modal style={{ width: '850px' }}
          footer={ this._renderFormConfigModalFooter() }
          onHide={() => this.setState({ displayConfigFormDialog: false })}>

          <div className="formConfigModal">
            { this._renderFormConfigGoogleTag() }
            { this._renderFormConfigLanguages() }
            { this._renderFormConfigPrismic() }
            { this._renderFormConfigMailTo() }
            { this._renderFormConfigPdfWidth() }
            { this._renderFormConfigDocumentGeneration() }
            { this._renderFormConfigWordScriptName() }
            { this._renderFormConfigDefaultSubmissionName() }
            { this._renderFormConfigTypeChoice() }
          </div>

        </Dialog>
      </>
    )
  }

  private _renderFormConfigGoogleTag() {
    return (
      <div>
        <label>GoogleTag: </label>
        <InputText className="p-inputtext-sm block mb-2"
                   placeholder="Google tag"
                   value={this.state.formConfig.googleTag ?? ''}
                   onChange={(e: any) => {
                     const formConfig = this.state.formConfig;
                     formConfig.googleTag = e.target.value;
                     this.setState({ formConfig });
                   }}
        />
      </div>
    )
  }

  private _renderFormConfigLanguages() {
    let formConfigLanguages: any[] = [];
    for (let language of this.state.formConfig.languages) {
      formConfigLanguages.push(language);
    }

    return (
      <>
        <div>
          <label id="languageTooltip">Languages : </label>
          <span style={{ display: 'flex', alignItems: 'center', gap: '5px' }}>
                <Chips
                  value={formConfigLanguages}
                  onChange={(e) => {
                    const formConfig = this.state.formConfig;
                    formConfig.languages = e.value;
                    this.setState({ formConfig });
                  }}
                />
          </span>

          <Tooltip target="#languageTooltip" position="top">
            <p>
              Allows defining the different languages available in the application.
              According to the languages currently defined in Prismic, the only possible values are fr-be, nl-be, en-eu.
              However, if a new language is added on Prismic's side, it should normally be available here as well.
            </p>
          </Tooltip>
        </div>
        <div>
          <label id="defaultLanguageTooltip">Default language : </label>
          <Dropdown
            value={this.state.formConfig.defaultLanguage ?? ''}
            appendTo={document.body}
            options={formConfigLanguages}
            onChange={(e) => {
              const formConfig = this.state.formConfig
              formConfig.defaultLanguage = e.target.value;
              this.setState({
                formConfig,
              })
            }}
            placeholder="Language name"
          />
          <Tooltip target="#defaultLanguageTooltip" position="top">
            <p>
              Allows the definition of a default language that will be used when a language has been made available
              in the languages defined in the application but is not yet available on Prismic or has not been properly
              defined.
            </p>
          </Tooltip>
        </div>
      </>
    )
  }

  private _renderFormConfigPrismic() {
    let formConfigPrismic: any[] = [];
    let commonPrismic: any[] = [];

    for (let prismic of this.state.formConfig.prismic) {
      if (!prismic.includes('common')) formConfigPrismic.push(prismic);

      else commonPrismic.push(prismic);
    }

    return (
      <div>
        <label id="prismicTooltip">Prismic<span style={{ color: '#e98b3a' }}>*</span> : </label>
        <Chips
          value={formConfigPrismic}
          onChange={(e) => {
            const formConfig = this.state.formConfig;
            formConfig.prismic = e.value.concat(commonPrismic);
            this.setState({ formConfig });
          }}
        />
        <Tooltip target="#prismicTooltip" position="top">
          <p>Names of the translation catalogues to be used in the application</p>
          <p>Write the key and press "enter" to add the key in the Prismic list.</p>
        </Tooltip>
      </div>
    )
  }

  private _renderFormConfigMailTo() {
    let formConfigMailsTo: any[] = [];
    for (let mailTo of this.state.formConfig.mailTo) {
      formConfigMailsTo.push(mailTo);
    }

    return (
      <>
        <div>
          <label id="mail_to_tooltip">Mail to : </label>
          <Chips className="p-inputtext-sm block mb-2"
                 placeholder="Mail to"
                 value={formConfigMailsTo}
                 onChange={(e: any) => {
                   const formConfig = this.state.formConfig;
                   formConfig.mailTo = e.value;
                   this.setState({ formConfig });
                 }}/>
        </div>
        <Tooltip target="#mail_to_tooltip" position="top">
          <p>The e-mail address for receiving feedback.
            You can press Enter to confirm an email address and add more!</p>
        </Tooltip>
      </>
    )
  }

  private _renderFormConfigPdfWidth() {
    return (
      <>
        <div>
          <label id="pdf_tooltip">PDF width: </label>
          <InputNumber className="p-inputtext-sm block mb-2"
                       placeholder="PDF width"
                       value={this.state.formConfig.pdfWidth ?? ''}
                       onChange={(e: any) => {
                         const formConfig = this.state.formConfig;
                         formConfig.pdfWidth = e.value;
                         this.setState({ formConfig });
                       }}
          />
        </div>
        <Tooltip target="#pdf_tooltip" position="top">Configure the width of the PDF generated from
          HTML.</Tooltip>
      </>
    )
  }

  private _renderFormConfigDocumentGeneration() {
    const documentOptions = [
      { label:"Docx generation", value:"docx"},
      { label:"Excel generation", value:"excel"},
      { label:"PDF from docx", value:"pdfDocx"},
      { label:"PDF from html", value:"pdfHtml"}
    ]

    const selectedValues:String[] = [];
    if (this.state.formConfig.docxGeneration) selectedValues.push('docx');
    if (this.state.formConfig.excelGeneration) selectedValues.push('excel');
    if (this.state.formConfig.pdfFromDocx) selectedValues.push('pdfDocx');
    if (this.state.formConfig.pdfFromHTML) selectedValues.push('pdfHtml');

    return (
      <>
        <div>
          <label id="document_tooltip">Documents : </label>
          <MultiSelect
            appendTo={document.body}
            value={selectedValues}
            options={documentOptions}
            onChange={(e) => {
              const formConfig = this.state.formConfig;
              formConfig.docxGeneration = e.value.includes('docx');
              formConfig.excelGeneration = e.value.includes('excel');
              formConfig.pdfFromDocx = e.value.includes('pdfDocx');
              formConfig.pdfFromHTML = e.value.includes('pdfHtml');
              this.setState({ formConfig });
            }}
            placeholder="Select Documents"
            className="w-full md:w-20rem"
          />
          <Tooltip target="#document_tooltip" position="top">
            <p>Document generated on the response screen</p>
            <br/>
            <p>
              If the pdf option is ticked, the pdf is generated on the basis of the docx generation, otherwise it
              is generated on the basis of the html result.
            </p>
          </Tooltip>
        </div>
      </>
    )
  }

  private _renderFormConfigWordScriptName() {
    const defaultScript = this.state.scriptList
      .find((s) => s.fileName === this.state.formConfig.defaultScriptName);

    return (
      <div>
        <label>Word Script : </label>
        <Dropdown
          value={defaultScript ?? null}
          appendTo={document.body}
          options={this.state.scriptList}
          onChange={(e) => {
            const formConfig = this.state.formConfig
            formConfig.defaultScriptName = e.value.fileName

            this.setState({
              formConfig,
            })

          }}
          optionLabel="fileName"
          filter
          filterBy="fileName"
          placeholder="Default script"
        />
      </div>
    )
  }

  private _renderFormConfigDefaultSubmissionName() {
    return (
      <>
        <div>
          <label id="default_submission_name_tooltip">Default Submission Name : </label>
          <Dropdown
            value={this.state.formConfig.defaultSubmissionName ?? ''}
            appendTo={document.body}
            options={this.props.decisionTrees}
            onChange={(e) => {
              const formConfig = this.state.formConfig
              formConfig.defaultSubmissionName = e.value
              this.setState({
                formConfig,
              })
            }}
            optionLabel="name"
            filter
            filterBy="name"
            placeholder="Default submission name"
          />
        </div>
        <Tooltip target="#default_submission_name_tooltip" position="top">
          <p>Decision tree for generating default names when a submission is saved by the user in their personal
            space</p>
        </Tooltip>
      </>
    )
  }

  private _renderFormConfigTypeChoice() {
    return (
      <>
        <div>
          <div>
            <label>Type : </label>
            <RadioButton style={{ marginRight: 5 }} name="form-type" value="graph"
                         checked={this.state.formConfig.type === FormType.GRAPH}
                         onChange={() => {
                           const formConfig = this.state.formConfig
                           formConfig.type = FormType.GRAPH
                           this.setState({
                             formConfig
                           })
                         }}></RadioButton>
            <label htmlFor="graph">Graph</label>
          </div>
          <div>
            <RadioButton style={{ marginRight: 5 }} name="form-type" value="requirement"
                         checked={this.state.formConfig.type === FormType.REQUIREMENT}
                         onChange={() => {
                           const formConfig = this.state.formConfig
                           formConfig.type = FormType.REQUIREMENT
                           this.setState({
                             formConfig
                           })
                         }}
            ></RadioButton>
            <label htmlFor="requirement">Requirement</label>
          </div>
        </div>
        {this.state.formConfig.type === FormType.GRAPH && (
          <>
            <div>
              <label>Graph : </label>
              <Dropdown
                value={this.state.formConfig.graphDecisionTree ?? ""}
                appendTo={document.body}
                options={this.props.decisionTrees.map(e => e.name)}
                onChange={(e) => {
                  const formConfig = this.state.formConfig
                  formConfig.graphDecisionTree = e.value
                  this.setState({
                    formConfig
                  })
                }}
                placeholder="Graph decision tree"
                required={this.state.formConfig.type === FormType.GRAPH}
              />
            </div>
            <div>
              <label>Schema : </label>
              <Dropdown
                value={this.state.formConfig.diagramDecisionTree ?? ""}
                appendTo={document.body}
                options={this.props.decisionTrees.map(e => e.name)}
                onChange={(e) => {
                  const formConfig = this.state.formConfig
                  formConfig.diagramDecisionTree = e.value
                  this.setState({
                    formConfig
                  })
                }}
                placeholder="Diagram decision tree"
                required={this.state.formConfig.type === FormType.GRAPH}
              />
            </div>
          </>

        )}
      </>
    )
  }

  //region FORMCONFIG FOOTER

  private _renderFormConfigModalFooter() {
    return (
      <>
        <div>
          <Button
            label="Cancel"
            icon="pi pi-times"
            style={{ backgroundColor: '#0087b7', borderColor: '#0087b7' }}
            className="p-button-danger"
            onClick={this._handleFormConfigFooterCancelClick}
          />
          <Button
            label="Save"
            style={{ backgroundColor: '#e98b3a', borderColor: '#e98b3a' }}
            className="p-button-danger"
            icon="pi pi-check"
            onClick={() => {
              this.props.saveFormConfig(this.state.formConfig);
              this.setState({ displayConfigFormDialog: false });
            }}
          />
        </div>
      </>
    )
  }

  private _handleFormConfigFooterCancelClick = () => {
    this.setState(
      { displayConfigFormDialog: false },

      () => {
        const formConfig = this.state.formConfig as any;

        formConfig.googleTag = this.props.form?.googleTag;
        formConfig.prismic = this.props.form?.prismic;
        formConfig.languages = this.props.form?.languages;
        formConfig.defaultLanguage = this.props.form?.defaultLanguage;
        formConfig.type = this.props.form?.type
        formConfig.pdfWidth = this.props.form?.pdfWidth;
        formConfig.docxGeneration = this.props.form?.docxGeneration;
        formConfig.excelGeneration = this.props.form?.excelGeneration;
        formConfig.pdfFromDocx = this.props.form?.pdfFromDocx;
        formConfig.pdfFromHTML = this.props.form?.pdfFromHTML;
        formConfig.mailTo = this.props.form?.mailTo;
        formConfig.graphDecisionTree = this.props.form?.graphDecisionTree
        formConfig.diagramDecisionTree = this.props.form?.diagramDecisionTree;
        formConfig.defaultSubmissionName = this.props.form?.defaultSubmissionName;
        formConfig.defaultScriptName = this.props.form?.defaultScriptName;

        this.setState({ displayConfigFormDialog: false });
      },
    )
  }

  //endregion


  //endregion

  //endregion

  render() {
    return (
      <div>
        <Toast ref={(el) => this.toast = el}/>
        <div>
          {this._renderQuestionsList()}
          {this._renderToolBarOfQuestionsList()}
        </div>
        {this._renderAddQuestionModal()}
        {this._renderDeleteAllQuestionsModal()}
        {this._renderFormConfigModal()}
      </div>
    );
  }

}

export default withTranslation()(FormEditorSidebar);
